import { IFileModel, IFileModelMediaUploader } from './file-model.interface';
import { ItemModel } from './items.interface';
import { IPlaqueItem } from './plaqueItem.interface';

export interface StoryPage {
  id?: number;
  title: string;
  description: string;
  attachments: IFileModel[];
}

export interface StoryItem {
  id: number;
  image: string;
  name: string;
}

export interface StoryContributor {
  id: number;
  name: string;
  image: string;
  email?: string;
  updatedAt?: string;
}

export interface Story {
  name: string;
  description: string;
  mainCover?: string;
  attachments: IFileModel[];
  pages: StoryPage[];
  item?: IPlaqueItem;
  status: 'draft' | 'live';
  plaqueImage: string;
  communityContributor: StoryContributor[];
  individualContributor: StoryContributor[];
}

export interface StoryIcon {
  icon: string;
  callback?: string;
}

export interface IPageModel {
  id: number;
  title: string;
  tempTitle?: string;
  description: string;
  blobUrl: string;
  typeId: number;
  attachments?: IFileModel[];
}

export interface IStoryModel {
  uniquePlaqueId: string;
  plaqueId?: number;
  lastModifiedOn: Date;
  plaqueTypeId: number;
  skuName: string;
  isLive: boolean;
  communityId: number;
  communityDisplayName: string;
  communityLastUpdatedOn: string | null;
  communityImageBlobUrl: string;
  coverPage: IPageModel;
  storyPages: IPageModel[];
  images: IFileModelMediaUploader[];
}

export type StoryViewFrom =
  | 'storyteller'
  | 'community'
  | 'plaque'
  | 'overview'
  | 'map'
  | 'gallery';

export interface StoryDialogConfig {
  story: IStoryModel | null;
  item: ItemModel | null;
  plaqueId?: number;
  itemId?: number;
  allowEdit: boolean;
  allowShare: boolean;
  fromModal: boolean;
  accessDraft: boolean;
  isPageClicked: boolean;
  pageIndex: number;
  selectedTab: 'story' | 'item';
  viewType: StoryViewFrom;
  campaignId: number | null;
  enableMeta: boolean;
  userAccessLevel?: boolean;
  isInteractiveTourCampaign?:boolean;
  isPrivateLink?:boolean;
  // Open the item straight at its shift or discount-group step (campaign overview cards).
  openStep?: 'shifts' | 'discountGroups';
  // Open the item's edit drawer straight away, without the viewer (campaign map pin card).
  openEdit?: boolean;
}
